/**
 *  See: RMA ADM A00430
 */
export const RmaCommodityTypeCodes = {
  // NOTE: RMA contains additional commodity type codes that are not included here as they are not used
  FarrowToFinish: '804',
  Finishing: '805',
  SewPigFinishing: '806',
  CalfFinishing: '807',
  YearlingFinishing: '808',
  Steers: '809',
  Heifers: '810',
  Brahman: '811',
  Dairy: '812',
  Calves: '813',
  SteersAndHeifers: '820',
  CullCows: '821',
  NoCommodityTypeSpecified: '997',
} as const;

export type RmaCommodityTypeCodes =
  (typeof RmaCommodityTypeCodes)[keyof typeof RmaCommodityTypeCodes];

/**
 *  See: RMA ADM A00430
 */
export const RmaCommodityTypeNames = {
  FarrowToFinish: 'Farrow to Finish',
  Finishing: 'Finishing',
  SewPigFinishing: 'Sew Pig Finishing',
  CalfFinishing: 'Calf Finishing',
  YearlingFinishing: 'Yearling Finishing',
  Steers: 'Steers',
  Heifers: 'Heifers',
  Brahman: 'Brahman',
  Dairy: 'Dairy',
  Calves: 'Calves',
  SteersAndHeifers: 'Steers and Heifers',
  CullCows: 'Cull Cows',
  NoCommodityTypeSpecified: 'No Commodity Type Specified',
} as const;
export type RmaCommodityTypeName =
  (typeof RmaCommodityTypeNames)[keyof typeof RmaCommodityTypeNames];
